import { useState } from "react"

import { useQuery, useQueryClient, userClient } from "@trueskin-web/apis"
import { Spinner, Tappable } from "@trueskin-web/components"

import UserNoteDialog from "./user-note-dialog"

const UserNote = () => {
  const queryClient = useQueryClient()

  const [isOpenDialog, setIsOpenDialog] = useState(false)

  const { data = {}, isLoading } = useQuery(
    "healthRecord",
    userClient.getHealthRecord
  )

  const { userNote } = data

  const handleSubmit = async () => {
    await queryClient.refetchQueries("healthRecord")

    setIsOpenDialog(false)
  }

  return isLoading ? (
    <Spinner size={16} sx={{ display: "block", mt: 4, mx: "auto" }} />
  ) : (
    <>
      <div
        sx={{
          mt: 3,
          color: "textDark",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
        data-testid="user-note-content"
      >
        {!!userNote ? (
          <span
            sx={{
              whiteSpace: "nowrap",
            }}
          >
            Deine Notiz: {userNote}
          </span>
        ) : (
          "Möchtest Du noch etwas mitteilen?"
        )}
      </div>

      <Tappable
        onClick={() => setIsOpenDialog(true)}
        sx={{
          mt: "2px",
          display: "inline-flex",
          alignItems: "center",
          lineHeight: "20px",
          color: "primary",
          cursor: "pointer",
        }}
        data-testid="user-note-open-dialog-button"
      >
        {!!userNote
          ? "Bearbeite die Notiz"
          : "Füge eine Notiz für Deinen Arzt/Deine Ärztin hinzu"}
      </Tappable>

      <UserNoteDialog
        isOpen={isOpenDialog}
        userNote={userNote}
        onDismiss={() => setIsOpenDialog(false)}
        onSubmit={handleSubmit}
      />
    </>
  )
}

export default UserNote
